export default class FinalizeTpClientInvoiceBulkItem {
  constructor() {
    this.IdListString = '';
    this.AllItemsInTheSearchSetAreSelected = false;
    this.NumberOfItemsSelected = 0;
  }
}
